module.exports = __webpack_public_path__ + "static/Mummy_Greater-eee98459412456ac87237ce06d7819ae.jpg";